module.exports = __webpack_public_path__ + "files/2aaec41ea2f65589862e8b0c48e16242.png";